function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import "./tableBody.css";
import { UnstyledTableBody } from "../../../unstyled/table/base/UnstyledTableBody";
/*
    Returns a list of rows for a table

    props
        (array, required)  columns    See description in TableHeader
        (array, required)  rows       List of objects, where each object has keys corresponding to column dataKeys
                                        - The value in each row object is the cell data to render (can be altered by renderCell function in column)
                                        - example = [ 
                                            { 
                                                name: "Guide Book", 
                                                count: 42 
                                            },
                                            { 
                                                name: "Pencil", 
                                                count: 1
                                            } 
                                        ]
        (string, required) minWidth   The minimum width of each row
*/

const TableBody = ({
  classPrepend = "styled",
  columns,
  rows,
  minWidth,
  expandedRowRender = null,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UnstyledTableBody, _extends({
    classPrepend: classPrepend,
    columns: columns,
    rows: rows,
    minWidth: minWidth,
    expandedRowRender: expandedRowRender
  }, rest));
};
export { TableBody };